import React from 'react'
import { Link } from "react-router-dom";

export default function GiftingHead() {
  return (
    <>
    <section className="haldipage-head">
        <div className="container">
            <div className="row justify-content-center">

                <div className="col-lg-10 col-md-10">
                    <span>Timeless Gifts of Love</span>
                    <h1>Crafted Elegance for Every Moment</h1>
                    <p>At Sonam Label, every gift is a celebration of elegance, emotion, and tradition. From hand-embellished keepsakes to personalised bridal treasures, our curated gifting collection blends artisanal craftsmanship with contemporary charm. Each piece is thoughtfully designed to honour relationships, commemorate special moments, and elevate every celebration with beauty, meaning, and heartfelt intention.</p>
                </div>

                <div className="col-lg-12 col-md-12">
                    <div className="gifthead-banner">
                        <img src="/image/gift-bird.webp" className="gifthead-bird wow animate__animated animate__fadeInUp" data-wow-duration="1s" data-wow-delay="0.2s" alt="bird"/>
                        <img src="/image/gift-banner.webp" className="img-responsive" alt="gifting"/>
                        <Link to={"/contact"} className="default-btn red-default">learn more</Link>
                    </div>
                </div>

            </div>
        </div>
    </section>
    </>
  )
}
